import React, { useState, useEffect } from 'react'
import MaterialTable from 'material-table'
import { Grid } from '@material-ui/core'
import { getStatusMipyme } from '../../services/Elegibilidad/get'

const TableInformative = ({ userIDB2C }) => {
  const [tableData, setTableData] = useState([])

  const getDataTable = async () => {
    try {
      const response = await getStatusMipyme(userIDB2C)

      if (response.Success) {
        setTableData(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getDataTable()
  }, [])

  const columns = [
    {
      title: 'Registro tributario',
      field: 'TaxRegistration',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'MIPYME',
      field: 'MipymeName',
      filtering: false,
      align: 'left',
    },
    {
      title: 'Proyecto',
      field: 'SubprojectName',
      filtering: false,
      align: 'left',
    },
    {
      title: 'Pre-Elegibilidad aprobada',
      field: 'PreelegibilityApproved',
      sorting: false,
      filtering: false,
      type: 'boolean',
      align: 'center',
    },
    {
      title: 'Taller Inicial aprobado',
      field: 'ApprovedWorkshop',
      sorting: false,
      filtering: false,
      type: 'boolean',
      align: 'center',
    },
    {
      title: 'Asociado a una IFI',
      field: 'AssociatedIfi',
      sorting: false,
      filtering: false,
      type: 'boolean',
      align: 'center',
    },
    {
      title: 'Disponible Presupuesto',
      field: 'MipymeWithAvailable',
      sorting: false,
      filtering: false,
      type: 'boolean',
      align: 'center',
    },
    {
      title: 'Préstamo Desembolso',
      field: 'MipymeWithCredit',
      sorting: false,
      filtering: false,
      type: 'boolean',
      align: 'center',
    },
    {
      title: 'Formulario Elegibilidad creado',
      field: 'ElegibilityRegistred',
      sorting: false,
      filtering: false,
      type: 'boolean',
      align: 'center',
    },
    {
      title: 'Habilitado Elegibilidad',
      field: 'CreateFomsEligibility',
      sorting: false,
      filtering: false,
      type: 'boolean',
      align: 'center',
    },
  ]

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={12} md={12}>
        <MaterialTable
          columns={columns}
          data={tableData}
          style={{
            height: '50',
            width: '10',
          }}
          onSelectionChange={(selectedRows) => console.log(selectedRows)}
          options={{
            sorting: true,
            search: true,
            searchFieldAlignment: 'right',
            searchAutoFocus: true,
            searchFieldVariant: 'standard',
            filtering: true,
            paging: true,
            pageSizeOptions: [5],
            pageSize: 5,
            paginationType: 'stepped',
            showFirstLastPageButtons: false,
            paginationPosition: 'bottom',

            exportFileName: 'TableData',
            addRowPosition: 'first',
            actionsColumnIndex: -1,
            showSelectAllCheckbox: false,
            showTextRowsSelected: false,
            toolbarButtonAlignment: 'left',
            selectionProps: (rowData) => ({
              disabled: rowData.age == null,
              // color:"primary"
            }),
            // rowStyle: (data, index) =>
            //   index % 2 === 0
            //     ? {
            //         background: '#f5f5f5',
            //         height: '1px',
            //         maxHeight: '2px',
            //         padding: 0,
            //       }
            //     : null,
            // headerStyle: {
            //   background: '#004BCE',
            //   color: '#fff',
            //   height: '1px',
            // },
            rowStyle: {
              height: '1px',
              maxHeight: '2px',
              padding: 0,
            },

            headerStyle: {
              background: '#014b96',
              color: '#fff',
              height: '1px',
            },
          }}
          localization={{
            body: {
              editRow: {
                deleteText: '¿Está seguro de eliminar el registro?',
              },
            },
            header: {
              actions: 'Acciones',
            },
            toolbar: {
              searchPlaceholder: 'Buscar',
            },
          }}
          title=" "
          // icons={{ Add: () => <AddIcon /> }}
        />
      </Grid>
    </Grid>
  )
}

export default React.memo(TableInformative)
